// extracted by mini-css-extract-plugin
export default {"fr-view":"Empty_fr-view__o8m2-","container":"Empty_container__nvpcb","image":"Empty_image__aHgtL"};